import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Services from "./pages/Services";
import Experience from "./pages/Projects";
import QualificationsSafety from "./pages/QualificationsSafety";
import Gallery from "./pages/Gallery";
import About from "./pages/About";
import Contact from "./pages/Contact";

const App = () => {
  return (
    <div>
      <Navbar />
      <main>
        <Header />
        <Services />
        <Experience />
        <QualificationsSafety />
        <Gallery />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default App;